<template>
  <VDialog v-model="dialog" width="600">
    <VCard>
      <VCardText>
        <div class="">
          <div class="">
            <VBtn
              fab
              text
              absolute
              style="right: 0"
              small
              @click="dialog = false"
            >
              <VIcon size="20"> mdi-close </VIcon>
            </VBtn>
            <VRow justify="center">
              <VCol md="12" cols="12">
                <VCardTitle class="px-0">{{
                  $t("placeProductIn", { warehouse: warehouse.name })
                }}</VCardTitle>
                <ValidationObserver
                  v-slot="{ handleSubmit }"
                  ref="formObserver"
                >
                  <form @submit.prevent="handleSubmit(placeProduct)">
                    <!--              <custom-input-text-->
                    <!--                  @input="searchProductByQr"-->
                    <!--                  label="ID"-->
                    <!--                  ref="qrId"-->
                    <!--                  clearable-->
                    <!--                  v-model="searchQr"-->
                    <!--                  class="no-margin user_input mb-3"-->
                    <!--              />-->
                    <div class="d-flex mx-n2 align-center">
                      <div class="px-2 flex-grow-1">
                        <VueSelect
                          :disabled="!!productDataQr"
                          rules="required"
                          infinite
                          @input="onInputProduct"
                          :get-item-promise="
                            ({ text, page }) =>
                              $store.dispatch('getProducts', {
                                limit: 15,
                                page,
                                name: text,
                              })
                          "
                          :label="$t('product') + '*'"
                          @next-page-resolved="
                            (data) => setProduct([...products, ...data])
                          "
                          @item-resolved="setProduct"
                          :items="products"
                          class="user_input no-margin mb-3"
                          v-model="productIncomeData.productId"
                        >
                          <template #option="{ item }">
                            <VListItemTitle>
                              <p class="ma-0">{{ item.name }}</p>
                              <span class="v-messages">{{
                                item.attrs.join(" && ")
                              }}</span>
                            </VListItemTitle>
                          </template>
                        </VueSelect>
                      </div>
                      <div class="px-2">
                        <VSwitch
                          hide-details
                          :label="$t('used')"
                          v-model="used"
                        ></VSwitch>
                      </div>
                    </div>
                    <VueSelect
                      ref="contractSelectRef"
                      infinite
                      v-model="productIncomeData.contractNumber"
                      :get-item-promise="getContracts"
                      :items="contracts"
                      :label="$t('nContract')"
                      item-text="code"
                      item-value="code"
                      @item-resolved="setContract"
                      @next-page-resolved="
                        (data) => setContract([...contracts, ...data])
                      "
                    >
                      <template #append:item="{ searchText }">
                        <VBtn
                          width="100%"
                          @click="onAddContract(searchText)"
                          color="primary"
                          >{{ $t("add") }}</VBtn
                        >
                      </template>
                    </VueSelect>
                    <NumberInput
                      rules="required"
                      :precision="2"
                      :label="$t('count') + '*'"
                      class="user_input no-margin mb-3"
                      v-model="productIncomeData.count"
                    />
                    <NumberInput
                      rules="required"
                      :label="$t('packageCount') + '*'"
                      class="user_input no-margin mb-3"
                      v-model="productIncomeData.packageCount"
                    />
                    <CustomSelect
                      rules="required"
                      :label="$t('measure') + '*'"
                      class="user_input no-margin"
                      :items="unitTypes"
                      :item-text="`name_${$i18n.locale}`"
                      v-model="productIncomeData.unitTypeId"
                    />
                    <VDivider class="mt-6" />
                    <VRow class="my-4" dense>
                      <VCol
                        class="cursor-pointer d-flex align-center px-2 py-2 no-wrap-text"
                        :key="stillageIndex"
                        v-for="(carriage, stillageIndex) in carriages"
                        >{{ stillageIndex + 1 }}. {{ carriage.name }}
                        <VSwitch
                          hide-details
                          class="my-0 ml-4 pt-0"
                          v-model="carriage.full"
                          true-value="false"
                          false-value="true"
                          :label="$t('hasPlace')"
                        ></VSwitch>
                      </VCol>
                    </VRow>
                    <div class="text-right pt-3">
                      <VBtn type="submit" color="primary">{{
                        $t("save")
                      }}</VBtn>
                    </div>
                  </form>
                </ValidationObserver>
              </VCol>
            </VRow>
          </div>
          <WarningDialog
            title=""
            no-text="no"
            @cancel="dialog = false"
            @apply="reset"
            yes-text="yes"
            description="wantAddProduct"
            v-model="wantAddProductConfirmDialog"
          />
        </div>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import NumberInput from "@/plugins/Vuetify/components/NumberInput";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import { debounce, trueSet } from "@/utils/pureFunctions";

const PRODUCT_INCOME_DATA = {
  count: null,
  packageCount: null,
  productId: null,
  qrCode: null,
  unitTypeId: null,
  contractNumber: null,
};

export default {
  name: "WarehouseViewDialog",
  components: { VueSelect, NumberInput, WarningDialog },
  data() {
    return {
      dialog: false,
      wantAddProductConfirmDialog: false,
      warehouse: {
        name: null,
      },
      used: false,
      searchQr: null,
      products: [],
      productIncomeData: { ...PRODUCT_INCOME_DATA },
      productDataQr: null,
      carriages: [],
      contracts: [],
    };
  },
  methods: {
    setProduct(products) {
      this.products = products;
    },
    onAddContract(code) {
      this.setContract([{ code }]);
      this.productIncomeData.contractNumber = code;
    },
    getContracts({ text, page } = { text: null, page: 0 }) {
      return this.$store.dispatch("getContracts", {
        isMakeContract: true,
        limit: 15,
        code: text,
        page,
      });
    },
    setContract(contracts) {
      this.contracts = contracts;
    },
    async openDialog(data) {
      this.warehouse.name = data.warehouseName;
      this.dialog = true;
      this.carriages = data.carriages.map((item) => {
        item.full = "false";
        return item;
      });
    },
    onInputProduct() {
      if (this.unitTypes.length === 1) {
        this.productIncomeData.unitTypeId = this.unitTypes[0].id;
      }
    },
    reset() {
      this.productDataQr = null;
      this.productIncomeData = { ...PRODUCT_INCOME_DATA };
      this.searchQr = null;
      this.$refs.formObserver.reset();
    },
    async placeProduct() {
      let {
        count,
        unitTypeId,
        qrCode,
        productId,
        packageCount,
        contractNumber,
      } = this.productIncomeData;
      const data = {
        count: count.replace(",", ".").replace(/\s/g, ""),
        unitTypeId,
        packageCount,
        contractNumber,
        carriages: this.carriages.map((item) => {
          return {
            carriageId: item.id,
            full: item.full,
          };
        }),
      };
      if (qrCode && this.productDataQr) {
        data.qrCode = qrCode;
      } else {
        data.productId = productId;
      }

      try {
        this.showLoading();
        const url = this.used
          ? "product-item/income-used"
          : "product-item/income";
        await this.$http.post(url, data);
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.$emit("saved");
        if (this.carriages.some((item) => trueSet(item.full))) {
          this.dialog = false;
        } else {
          this.wantAddProductConfirmDialog = true;
        }
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    searchProductByQr: debounce(async function (val) {
      try {
        const {
          data: { data },
        } = await this.$http.get(`product-item/detail-by-qr-code/${val}`);
        this.productDataQr = data;
        this.products = [
          { name: data.productName, id: data.id, unitTypes: data.unitTypes },
        ];
        this.productIncomeData = {
          PRODUCT_INCOME_DATA,
          productId: data.id,
          qrCode: val,
        };
      } catch (e) {
        this.productDataQr = null;
        this.productIncomeData.productId = null;
      }
    }, 300),
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.productIncomeData = { ...PRODUCT_INCOME_DATA };
        this.carriages = [];
        this.$refs.formObserver.reset();
        this.$refs.contractSelectRef.reset();
        this.$emit("CloseWarehouseViewDialog", val);
      }
    },
  },
  computed: {
    unitTypes() {
      const selectedProduct = this.products.find(
        (item) => item.id === this.productIncomeData.productId
      );
      if (!selectedProduct) return [];
      return selectedProduct.unitTypes;
    },
  },
};
</script>

<style scoped></style>
